/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

require('jquery-ui');
require('jquery-mask-plugin');
require('jquery-datetimepicker');
require('moment');
//window.Instascan = require('instascan');
window.moment = require('moment');
window.Quill = require('quill');

// Select2
require('select2');
//$.fn.select2.amd.define('select2/i18n/pt-br',[],require("select2/src/js/select2/i18n/pt-br"));

window.Chart = require('chart.js');

// Sistema
require('./fox.js');

window.Vue = require('vue').default;

import BootstrapVue from 'bootstrap-vue' //Importing
Vue.use(BootstrapVue) // Telling Vue to use this in whole application

// Vue Router
//window.VueRouter = require('vue-router');
//Vue.component('vue-router', VueRouter.VueRouter);

// vSelect
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

// VueDatetime
import { Datetime } from 'vue-datetime';
Vue.component('datetime', Datetime);


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('product-search', require('./components/ProductSearch.vue').default);
Vue.component('auth-pin', require('./components/auth/Pin.vue').default);
Vue.component('message', require('./components/Message.vue').default);
Vue.component('jsqr', require('./components/jsQR.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*const app = new Vue({
    el: '#app',
});*/
